import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ImportElements";
var classes = {
    importElement: "".concat(PREFIX, "-importElement"),
    kGridContainer: "".concat(PREFIX, "-kGridContainer"),
    kGridContainerSingle: "".concat(PREFIX, "-kGridContainerSingle")
};
var StyledImportElements = styled(Box)(function (_a) {
    var _b, _c, _d, _e, _f;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.down("md")] = {
            paddingRight: 0,
            ".ImportElements-NoElementCard": {
                display: "none"
            }
        },
        _b["& .".concat(classes.importElement)] = (_c = {},
            _c[theme.breakpoints.down("md")] = {
                width: "8rem"
            },
            _c[theme.breakpoints.down("sm")] = {
                width: "6rem"
            },
            _c),
        _b["& .".concat(classes.kGridContainer)] = (_d = {},
            _d[theme.breakpoints.down("md")] = (_e = {
                    overflow: "auto",
                    overflowY: "scroll",
                    "::-webkit-scrollbar": {
                        display: "none" /* Chrome */
                    },
                    msOverflowStyle: "none" /* IE and Edge */,
                    scrollbarWidth: "none" /* Firefox */,
                    height: "90vh",
                    width: "inherit",
                    ol: {
                        paddingLeft: theme.spacing(0.5)
                    }
                },
                _e["& .".concat(classes.importElement)] = {
                    marginTop: "4px !important",
                    ".ImportElement-mediaType": {
                        display: "none"
                    },
                    ".ImportElement-date": {
                        display: "none"
                    },
                    ".ImportElement-filename": {
                        overflowWrap: "break-word"
                    }
                },
                _e),
            _d),
        _b["& .".concat(classes.kGridContainerSingle)] = (_f = {},
            _f[theme.breakpoints.down("md")] = {
                ol: {
                    paddingLeft: theme.spacing(0.5)
                },
                width: "15rem",
                ".ElementSummary ": {
                    width: "10rem"
                }
            },
            _f[theme.breakpoints.down("sm")] = {
                width: "6rem",
                paddingLeft: theme.spacing(0),
                marginLeft: theme.spacing(0.5),
                ".ElementSummary": {
                    width: "6rem",
                    ".ImportElement-mediaType": {
                        display: "none"
                    },
                    ".ImportElement-date": {
                        display: "none"
                    },
                    ".ImportElement-filename": {
                        overflowWrap: "break-word"
                    }
                }
            },
            _f),
        _b);
});

export { classes, StyledImportElements as default };
//# sourceMappingURL=index.styled.js.map
